import { Components, Theme } from "@mui/material";

export const MuiAutocomplete: Components<Theme>["MuiAutocomplete"] = {
  styleOverrides: {
    root: {},
    paper: ({ theme }) => ({
      marginTop: theme.spacing(3),
      borderRadius: theme.shape.borderRadius * 0.75,
    }),
    listbox: ({ theme }) => ({
      padding: theme.spacing(2),

      "& .MuiAutocomplete-option": {
        borderRadius: theme.shape.borderRadius * 0.75,
      },
    }),
  },
};
